import { generateClient } from "aws-amplify/api";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getContent } from "../../graphql/queries";
import { Box, Stack, Typography } from "@mui/material";
import ReadOnlyInput from "../../components/ReadOnlyInput";
import ManifestPreview from "../../components/ManifestPreview";
import CustomBreadcrumbs from "../../components/BreadCrums";
import { useSelector } from "react-redux";

const ViewContent = () => {
  const params = useParams();
  const client = generateClient();
  const [content, setContent] = useState(null);
  const successState = useSelector((state) => state.success.successState);

  const breadcrumbItems = [
    { label: "Content Management", link: "/content" },
    { label: "Content Listing", link: "/content" },
    { label: content ? content?.title : "View Content", link: null }, // The current page doesn't need a link
  ];

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await client.graphql({
          query: getContent,
          variables: {
            id: params.id,
          },
        });

        setContent(response.data.getContent);
      } catch (error) {}
    };
    fetchContent();
  }, [successState.success]);

  return (
    <div>
      <CustomBreadcrumbs items={breadcrumbItems} />
      {content && <ManifestPreview loading={false} contentValues={content} />}
    </div>
  );
};

export default ViewContent;
